import axiosPrivateMl from "@services/axiosPrivateMl"
import {
  SAVE_FB_ADS_LAUNCH_URL,
  LAUNCH_FB_ADS_BY_BATCH,
  FETCH_FB_AD_LAUNCH_LOGS,
  LAUNCH_SINGLE_FB_ADS_BY_LAUNCH_ID,
  QUICK_LAUNCH,
} from "../../constants"

export const submitSaveAdsForLaunch = (data) => {
  return axiosPrivateMl.post(SAVE_FB_ADS_LAUNCH_URL, data)
}

export const submitSaveQuickLaunchAdsForLaunch = (data) => {
  return axiosPrivateMl.post(QUICK_LAUNCH, data)
}

export const submitFBAdsForPosting = async (
  batchId,
  userId,
  retryFailed = false,
  quick_launch_id = null
) => {
  try {
    const response = await axiosPrivateMl.post(LAUNCH_FB_ADS_BY_BATCH, {
      batch_id: batchId,
      user_id: userId,
      retry_failed: retryFailed,
      quick_launch_id: quick_launch_id
    })
    return response
  } catch (error) {
    console.error("Error submitting Facebook ads for posting:", error)
    throw error
  }
}

export const fetchFBAdLaunchLogs = async (batchId) => {
  try {
    const response = await axiosPrivateMl.post(FETCH_FB_AD_LAUNCH_LOGS, {
      batch_id: batchId,
    })
    return response
  } catch (error) {
    console.error("Error fetching Facebook ad launch logs:", error)
    throw error
  }
}

export const launchSingleFBAdsByLaunchId = async (launchId) => {
  try {
    const response = await axiosPrivateMl.post(
      LAUNCH_SINGLE_FB_ADS_BY_LAUNCH_ID,
      { launch_id: launchId }
    )
    return response
  } catch (error) {
    console.error("Error launching single Facebook ad by launch ID:", error)
    throw error
  }
}
